module.exports = __webpack_public_path__ + "img/icon_window_close.2e40d113.svg";